import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Check, Loader2 } from 'lucide-react';
import { Status } from '../types';
import { getStatusColor } from '../utils/statusColors';
interface StatusPillProps {
  status: Status;
  isOpen: boolean;
  isSaving: boolean;
  onToggle: () => void;
  onSelect: (status: Status) => void;
}
const statusOptions: Status[] = ['Started', 'In Process', 'Validated & Locked', 'Sent to LO for Validation', 'Pending Revision', 'Pending Level 2 Sign-off', 'Pending Payment', 'Paid by ACH', 'Paid by Check', 'Paid by Wire'];
export function StatusPill({
  status,
  isOpen,
  isSaving,
  onToggle,
  onSelect
}: StatusPillProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        if (isOpen) {
          onToggle();
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onToggle]);
  const handleSelect = (newStatus: Status) => {
    onSelect(newStatus);
  };
  return <div ref={dropdownRef} className="relative inline-block min-w-[220px]" data-id="element-193">
      <button onClick={e => {
      e.stopPropagation();
      onToggle();
    }} disabled={isSaving} className={`w-full px-3 py-2 rounded-lg text-sm font-semibold flex items-center justify-between gap-2 transition-colors ${getStatusColor(status)} ${isSaving ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-194">
        <span className="truncate" data-id="element-195">{status || 'Not Set'}</span>
        {isSaving ? <Loader2 className="w-4 h-4 animate-spin" data-id="element-196" /> : <ChevronDown className="w-4 h-4 flex-shrink-0" data-id="element-197" />}
      </button>

      <AnimatePresence data-id="element-198">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.15
      }} className="absolute left-0 top-full mt-1 w-full bg-white rounded-lg border border-slate-200 shadow-lg z-10 py-1 max-h-80 overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-199">
            {statusOptions.map(option => <button key={option} onClick={() => handleSelect(option)} className={`w-full px-3 py-2 text-sm font-semibold text-left flex items-center justify-between gap-2 transition-colors ${getStatusColor(option)}`} data-id="element-200">
                <span data-id="element-201">{option}</span>
                {status === option && <Check className="w-4 h-4" data-id="element-202" />}
              </button>)}
          </motion.div>}
      </AnimatePresence>
    </div>;
}